import React from "react";
import { SwapOutlined } from "@ant-design/icons";
import { CompanyCardData } from "./types";
import { SectionBlock, LeadText } from "./shared";

interface Props {
  data: Pick<CompanyCardData, "peer_metric_label" | "peers" | "peer_summary">;
}

const PeerComparison: React.FC<Props> = ({ data }) => (
  <SectionBlock
    icon={<SwapOutlined />}
    title="How it compares to its peers"
    subtitle={data.peer_metric_label}
  >
    <div className="flex flex-col gap-3 mt-2">
      {data.peers.map((peer, i) => (
        <div key={i}>
          <div className="flex justify-between text-[13px] mb-1 font-dm">
            <span
              className={
                peer.is_subject
                  ? "text-neutral font-semibold"
                  : "text-neutral/70"
              }
            >
              {peer.label}
            </span>
            <span className="text-neutral/70">{peer.value}</span>
          </div>
          <div className="h-[9px] rounded-full bg-grey/20 overflow-hidden">
            <div
              className={`h-full rounded-full ${
                peer.is_subject ? "bg-primary" : "bg-grey/60"
              }`}
              style={{ width: `${peer.bar_pct}%` }}
            />
          </div>
        </div>
      ))}
    </div>

    <p
      className="mt-3.5 text-[14px] text-neutral/70 font-dm m-0"
      dangerouslySetInnerHTML={{ __html: data.peer_summary }}
    />
  </SectionBlock>
);

export default PeerComparison;
